import React from 'react';
import { MultiSelect } from '@storable/canaveral-components';
import PropTypes from 'prop-types';
import Icon from '../../../../../modules/react/components/stateless/Icon';
import style from './AmenitiesSelector.scss';

const max = 12;
const min = 1;

const propTypes = {
  disableNextBtn: PropTypes.func.isRequired,
  facility: PropTypes.shape({
    amenities: PropTypes.arrayOf(PropTypes.object({
      name: PropTypes.string,
      desription: PropTypes.string,
    })),
  }).isRequired,
  amenities: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateAmenities: PropTypes.func.isRequired,
};

const defaultProps = {};

class AmenitiesSelector extends React.Component {
  componentDidMount = () => {
    const { disableNextBtn, amenities } = this.props;
    disableNextBtn(!amenities.length >= min);
  }

  onChange = (value) => {
    const { disableNextBtn, amenities, updateAmenities } = this.props;

    let newAmenities;

    if (amenities.find(amenity => amenity.name === value)) {
      newAmenities = amenities.filter(opt => opt.name !== value);
    } else {
      newAmenities = [...amenities, { name: value }];
    }
    updateAmenities(newAmenities);
    disableNextBtn(!newAmenities.length >= min);
  }

  render() {
    const { facility, amenities } = this.props;

    const availableAmenities = facility.amenities.map(amenity => amenity.name);
    const amenityOpts = availableAmenities.map(amenity => (
      <MultiSelect.Item
        value={amenity}
        selected={amenities.find(am => am.name === amenity)}
        key={amenity}
      >
        {amenity}
      </MultiSelect.Item>
    ));

    const multiSelectProps = {
      onChange: this.onChange,
      selectedOptions: amenities.map(amenity => amenity.name),
      counterMessage: `${amenities.length} of ${max}`,
      maxxed: amenities.length === max,
      emptyMessage: (
        <span>
          Select an amenity from the left and click the
          <span className={style.arrow}>
            <Icon id="arrow-right" label="add amenity arrow" />
          </span>
          arrow to select it and move it here
        </span>
      ),
    };

    return (
      <div>
        <MultiSelect {...multiSelectProps}>
          {amenityOpts}
        </MultiSelect>
      </div>
    );
  }
}

AmenitiesSelector.propTypes = propTypes;
AmenitiesSelector.defaultProps = defaultProps;

export default AmenitiesSelector;
